"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Title = void 0;
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _typography = require("@berlitz/globals/lib/components/typography");
function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}
var Title = (0, _styledComponents.default)(_typography.H3).withConfig({
  displayName: "style__Title",
  componentId: "sc-11mait6-0"
})(["color:", ";"], function (_ref) {
  var theme = _ref.theme,
    color = _ref.color;
  return theme.colors[color];
});
exports.Title = Title;